function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '@isyc-react/design/overlays';
import { ViewerControlTooltip } from "../../tooltip";
import { nsarchives } from "../../../../../i18n/namespaces";
import clsx from 'clsx';
import { ViewerControlButton } from "../button";
import "./control-responsive-overlay.style.scss";

// interface ControlItemProps {
// }
// const ControlItem: React.FC<ControlItemProps> = props => {
//   const { onClick, children, active } = props
//   return (
//     <div className='zoom-item' onClick={() => onClick && onClick()}>
//       <div className='tick'>{active && <i className='mdi mdi-check text-primary'></i>}</div>
//       <div>{children}</div>
//     </div>
//   )
// }
export const ViewerControlResponsiveOverlay = props => {
  const {
    children
  } = props;
  const [show, setShow] = React.useState(false);
  const {
    t
  } = useTranslation(nsarchives.common);
  return /*#__PURE__*/React.createElement(Dropdown, {
    alignEnd: false,
    show: show,
    onToggle: nextShow => setShow(nextShow),
    drop: 'down'
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, null, (toggleProps, meta) => /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: t('archive.view.controls.generic'),
    show: show ? false : undefined
  }, /*#__PURE__*/React.createElement(ViewerControlButton, _extends({}, toggleProps, {
    onClick: () => meta.toggle(!show),
    className: clsx({
      'control-responsive-active': show
    })
  }), /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-dots-vertical"
  })))), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    flip: false,
    offset: [0, 0]
  }, (menuProps, meta) => /*#__PURE__*/React.createElement("div", _extends({}, menuProps, {
    className: "control-responsive-overlay"
  }), children)));
};